module.exports = __webpack_public_path__ + "static/media/branco_diamante.f0aff6d1.jpg";